import React, { useEffect, useState } from "react"
import { get } from "lodash"
import PropTypes from "prop-types"

import SpinnerLoad from "../SpinnerLoad"
import Typograph from "../../../../components/Typograph"

import styles from "./styles.css"

import { isCpf } from "services/utils/regexForValidations"
import { TYPE_OF_SALE } from "../../Pages/NewSale/constants"

const OrderResume = ({
  formValues,
  onSubmit,
  saleDone,
  typeOfSale,
  ableSubmit,
  loading
}) => {
  const [order, setOrder] = useState([])
  const [numbers, setNumbers] = useState([])

  const isPort = typeOfSale === TYPE_OF_SALE.PORTABILITY.TITLE
  const typeOfSaleString = isPort
    ? TYPE_OF_SALE.PORTABILITY
    : TYPE_OF_SALE.NEW_SALE

  useEffect(() => {
    const portableNumbers = get(formValues, "phonesPortability", [])
    const assigneeName = get(formValues, "assigneeName", "")
    const assigneeDoc = get(formValues, "assigneeDoc", "")
    const uf = get(formValues, "uf", "")
    const areaLocal = get(formValues, "areaLocal", "")
    const locality = get(formValues, "locality", "")
    const qnt = get(formValues, "qnt", "")

    const customer = [
      { label: "Cliente:", value: assigneeName },
      { label: "UF:", value: uf },
      { label: "Área Local:", value: areaLocal },
      { label: "Localidade:", value: locality },
      { label: "Qtd. de números:", value: qnt }
    ]

    const mergedArray = [...order]

    customer.forEach((newItem) => {
      const existingItemIndex = mergedArray.findIndex(
        (oldItem) => oldItem.label === newItem.label
      )

      if (existingItemIndex !== -1) {
        mergedArray[existingItemIndex] = {
          ...mergedArray[existingItemIndex],
          value: newItem.value
        }
      } else if (newItem.value) {
        mergedArray.push(newItem)
      }
    })

    let customerUpdated = [...mergedArray]

    if (assigneeDoc) {
      const existDocument = customerUpdated.find(
        (obj) => obj.label === "CPF:" || obj.label === "CNPJ:"
      )
      customerUpdated.splice(1, existDocument ? 1 : 0, {
        label: `${isCpf(assigneeDoc) ? "CPF:" : "CNPJ:"}`,
        value: assigneeDoc
      })
    }

    if (assigneeDoc && isCpf(assigneeDoc)) {
      customerUpdated = customerUpdated.filter((obj) => obj.label !== "CNPJ:")
    } else {
      customerUpdated = customerUpdated.filter((obj) => obj.label !== "CPF:")
    }

    setOrder(customerUpdated)
    setNumbers(portableNumbers)
  }, [formValues])

  return (
    <div>
      {saleDone ? (
        <Typograph
          htmlTag="h1"
          size="x_large"
          weight="bold"
          color="outer_space"
        >
          Resumo da {typeOfSaleString.TITLE.toLowerCase()}
        </Typograph>
      ) : (
        <Typograph
          htmlTag="h1"
          size="x_large"
          weight="bold"
          color="outer_space"
        >
          Resumo do pedido
        </Typograph>
      )}
      {order.length === 0 && !typeOfSale ? (
        <p className={styles.empty}>Aguardando preenchimento...</p>
      ) : (
        <div className={`fullWidth ${styles.containerResume}`}>
          <div className={styles.titleResume}>{typeOfSale}</div>
          <ul>
            {order.map((item, i) => {
              return (
                <div key={i}>
                  {isPort && i === 1 && (
                    <div>
                      {i !== 0 && <hr />}
                      <li>
                        {numbers.length > 1 ? (
                          <div className={styles.label_ported_numbers}>
                            Números a serem portados:{" "}
                          </div>
                        ) : (
                          <div>Número a ser portado:</div>
                        )}

                        {isPort && i === 1 && (
                          <ul>
                            {numbers.map((element, i) => (
                              <li key={i} style={{ padding: 0 }}>
                                <div
                                  className={`${styles.value_list} ${styles.list_phones}`}
                                >
                                  {element.phone}
                                </div>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    </div>
                  )}
                  {i !== 0 && <hr />}
                  <li>
                    <div>{item.label}</div>
                    <div className={styles.value_list}>{item.value}</div>
                  </li>
                </div>
              )
            })}
          </ul>
        </div>
      )}

      {!saleDone && (
        <button
          type={"button"}
          disabled={!ableSubmit}
          className={styles.buttonFinishSale}
          onClick={() => onSubmit()}
          tabIndex={11}
        >
          {loading ? (
            <SpinnerLoad
              isButton
              personalStyle={{
                borderColor: "#ffffff",
                borderTopColor: "#ffffff"
              }}
            />
          ) : (
            `Concluir ${typeOfSaleString.DESC}`
          )}
        </button>
      )}
    </div>
  )
}

OrderResume.propTypes = {
  formValues: PropTypes.object.isRequired,
  typeOfSale: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  saleDone: PropTypes.bool,
  ableSubmit: PropTypes.bool,
  loading: PropTypes.bool
}

export default OrderResume



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/OrderResume/index.js